// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.email[data-v-a6a49e7a],.phone[data-v-a6a49e7a]{\n    margin-right:3px;\n}\n", ""]);
// Exports
module.exports = exports;
